import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet";

import HeroSection from "./HeroSection";

const OverviewSection = lazy(() => import("./OverviewSection"));
const BenefitSection = lazy(() => import("./BenefitSection"));
const WhyChooseSection = lazy(() => import("./WhyChooseSection"));

const FinancialServices = () => {
  return (
    <>
      <Helmet>
        <title>
          Financial Services & Secure File Transfers | LENTERA Finance
          Solutions.
        </title>
        <meta
          name="description"
          content="Improve security, automate operations and streamline money management for individuals and businesses."
        />
        <meta
          name="keywords"
          content="LENTERA finance services, money management solutions, financial planning support, streamlined financial operations.Education "
        />
      </Helmet>

      <HeroSection />

      <Suspense fallback={<div className="h-[400px]" />}>
        <OverviewSection />
        <BenefitSection />
        <WhyChooseSection />
      </Suspense>
    </>
  );
};

export default FinancialServices;
